export default __webpack_public_path__ + "static/media/photo--lg--misc-18.1b160e7c.jpg";